import React from "react";

import API from "@beardeddevops/react.api";
import Types from "constants/Types";
import Framework from "@beardeddevops/react.framework";
import {Button} from "reactstrap";
import ReactTable from "react-table";
import {Link} from "react-router-dom";
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import Edit from '@material-ui/icons/Edit'
import TextField from "@material-ui/core/TextField";
import SaveIcon from "@material-ui/icons/Save";
import {Tooltip} from "@material-ui/core";
import Send from "@material-ui/icons/Send";

export default class AvKeys extends Framework.Components.Collection {
	constructor(props) {
		let model = new API.BuildClass(Types.Av_Keys._name, API.RequestType.READ_ALL);
		super(props, model);
		this.state.limit = 16;
		this.state.currentEdit = null;
		this.state.newValue = null;
	}

	fetchData = async (state) => {
		this.state.sorted = [];
		this.state.page = 0;
		if (typeof(this.state.filter) === "undefined" || Array.isArray(this.state.filter)) {
			this.state.filter = {};
		}
		this.setState({loading: true});
		window.setTimeout(() => {
			this.fetchDataActual(state);
		}, 100);
	}

	sendEmail = async (pkey) => {
		let model = new API.BuildClass(Types.Av_Keys._name, API.RequestType.UPDATE);
		model.object.pkey = pkey;
		await model.submit(null, 'POST_CHECK_STRIPE_SUB');
	}

	render() {
		const {data, pages, limit, loading, columnsAnchor} = this.state;
		const extraColumns = [
			{
				Header: 'Order Number',
				id: "order_number",
				accessor:obj => obj.order_number,
				show: !!this.state['column_order_number'],
				toggle: 'column_order_number'
			}
		];
		const columns = [
			...extraColumns,
			{
				Header: "Product Name",
				id: "product_name",
				accessor: obj => (obj.product_name)
			},
			{
				Header: "Activation Key",
				id: "activation_key",
				accessor: obj => (obj.activation_key)
			},
			{
				Header: "License Code",
				id: "license_code",
				accessor: obj => (obj.license_code ?? "")
			},
			{
				Header: "Customer",
				id: "customers.name_first",
				accessor: obj => (obj.customers ? obj.customers.name : "")
			},
			{
				Header: "Email",
				id: "email_to",
				accessor: obj => (obj.email_to)
			},
			{
				Header: "Sent Date",
				id: "email_sent",
				accessor: obj => (obj.email_sent)
			},
			{
				Header: "Sold By",
				id: "user_who_sold.name_first",
				accessor: obj => (obj.user_who_sold ? obj.user_who_sold.name_first : "")
			},
			{
				Header: "Used",
				id: "used",
				width: 100,
				accessor: obj => (obj.used ? 'True' : 'False')
			},
			{
				Header: "",
				className: "button-cell",
				filterable: false,
				sortable: false,
				width: 45,
				Cell: props => {
					return (
						<>
							{!props.original.email_sent && <Button color="info" size={"sm"} block={true} onClick={async () => {await this.sendEmail(props.original.pkey)}}>
								<Send fontSize={'small'}/>
							</Button>}
						</>
					);
				}
			}
		]
		return (
			<Card>
				<CardContent>
					<div className="box-body">
						<div className="table-bar">
							<div className="d-flex">
								{this.renderSearch('AV Keys', "")}
								{this.renderHeaderRight("AV Keys", columns, extraColumns, columnsAnchor, this.handleOpen, this.handleClose)}
							</div>
						</div>
					</div>
					<ReactTable
						key={this.state.key}
						columns={columns}
						manual // Forces table not to paginate or sort automatically, so we can handle it server-side
						data={data}
						pages={pages} // Display the total number of pages
						loading={loading} // Display the loading overlay when we need it
						loadingText="Requesting Data"
						onFetchData={this.fetchData} // Request new data when things change
						expanderDefaults={{
							sortable: true,
							resizable: true,
							filterable: false,
							width: undefined
						}}
						defaultSorted={[
							{
								id: this.model.sort,
								desc: this.model.order === 'desc'
							}
						]}
						showPagination={true}
						defaultPageSize={limit}
						className="-striped -highlight"
						onPageSizeChange={this.onPageSizeChange}
						pageSize={limit}
					/>

					<Framework.Elements.LoadingSpinner isLoading={loading}/>
				</CardContent>
			</Card>
		)
	}
}
